import React from 'react';
import { AccordionRuleHeader } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/AccordionRuleHeader';
import { useGetExpenseSettingsSubheader } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/ExpenseSettingsRule/hooks/useGetExpenseSettingsSubheader';

export interface ExpenseSettingsRuleHeader {
  isActive: boolean;
  expenseCodesForLabel: string;
}

export function ExpenseSettingsRuleHeader({
  isActive,
  expenseCodesForLabel,
}: ExpenseSettingsRuleHeader): JSX.Element {
  const { subheader } = useGetExpenseSettingsSubheader({
    expenseCodesForLabel,
  });
  return (
    <AccordionRuleHeader
      showSubheader={!isActive}
      header="Expense settings"
      subheader={subheader}
    />
  );
}
